export default "__VITE_ASSET__38513dc5__"